import _ from 'lodash';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, SimpleChanges, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { CampaignService } from '../../services/campaign.service';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { LongPledgePresetOptionSchema } from '../../structure/long-pledge';
import { ImageService } from 'app/core/services/image.service';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

import * as DialogActions from 'app/dialog/features/dialog.actions';
import { select, Store } from '@ngrx/store';
import { selectCampaignSelected } from '../../features/campaign.selectors';
import { newAddCampaignPresetOption, newCreateCampaignPresetOption, newUpdateCampaignPresetOption } from '../../features/campaign.actions';
import { CampaignFormService } from '../../services/campaign-form.service';
import { ToastService } from 'app/toast/services/toast.service';
import { ChooseImageModalService } from 'app/core/services/choose-image-modal.service';
import { AMOUNT_LIMIT } from 'app/virtual-event/virtual-event.enums';

@Component({
  selector: 'app-campaign-long-pledge-option',
  templateUrl: './campaign-long-pledge-option.component.html',
  styleUrls: ['./campaign-long-pledge-option.component.scss']
})
export class CampaignLongPledgeOptionComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() formGroupCampaignTypeData: any = null;
  @Input() selected: any = null;

  @Output() onChangeData: EventEmitter<any> = new EventEmitter();

  public AMOUNT_LIMIT = AMOUNT_LIMIT;

  public campaign$ = this.store.pipe(
    select(selectCampaignSelected)
  );
  public campaign = null;

  public option: UntypedFormGroup = null;
  public additionalInfoSelect: UntypedFormControl = null;
  public additionalInfoSelectRequiredClassess = {
    'd-none': true
  };

  public value: any = null;

  public quillOptions = {
    showToolbarList: false,
    size: 'sm'
  }
  
  public takeUntilSubject: Subject<any> = new Subject();

  constructor(
    private store: Store,
    private fb: UntypedFormBuilder,
    private campaignService: CampaignService,
    private campaignFormService: CampaignFormService,
    private imageService: ImageService,
    private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private toastService: ToastService,
    private chooseImageModalService: ChooseImageModalService,
  ) { }

  ngOnInit(): void {
    const { selected } = this;

    this.campaign$.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(campaign => {
      this.campaign = campaign;
    });

    if(this.selected) {
      this.setImageValueByType(selected, 'image')
      this.setImageValueByType(selected, 'thumbnail')

      this.option = this.selected;
      this.value = _.cloneDeep(this.selected.value);
    } else {
      this.option = this.fb.group({});
      this.campaignService.generateForm(this.option, LongPledgePresetOptionSchema);
    }

    this.additionalInfoSelect = this.option.get('additionalInfoSelect') as UntypedFormControl;    
    this.reNgOnInit();
  }

  ngAfterViewInit(): void {
    window['$']('[data-toggle="tooltip"]').tooltip(
      {
        placement: 'left',
        trigger: 'click',
        html: true,
        template: '<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' 
    }
    )
  }

  reNgOnInit() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilSubject = new Subject();

    const additionalInfoSelectRequired = this.option.get('additionalInfoSelectRequired');
    this.additionalInfoSelectRequiredClassess['d-none'] = !additionalInfoSelectRequired.value;

    this.setImageSubscriptions('image');
    this.setImageSubscriptions('thumbnail');

    this.option.get('additionalInfoRequired').valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((value) => {
      const additionalInfoDesc = this.option.get('additionalInfoDesc');
      const additionalInfoDetail = this.option.get('additionalInfoDetail');

      if(value) {
        additionalInfoDesc.setValue("");
        additionalInfoDetail.setValue("");

        additionalInfoDesc.clearValidators();
        additionalInfoDetail.clearValidators();

        additionalInfoDesc.setValidators([Validators.required]);

        additionalInfoDesc.updateValueAndValidity();
        additionalInfoDetail.updateValueAndValidity();
      } else {
        additionalInfoDesc.setValue("");
        additionalInfoDetail.setValue("");

        additionalInfoDesc.clearValidators();
        additionalInfoDetail.clearValidators();

        additionalInfoDesc.updateValueAndValidity();
        additionalInfoDetail.updateValueAndValidity();
      }
    });

    this.option.get('additionalInfoSelectRequired').valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((value) => {
      const additionalInfoSelectDesc = this.option.get('additionalInfoSelectDesc');
      const additionalInfoSelect = this.option.get('additionalInfoSelect');

      if(value) {
        additionalInfoSelectDesc.setValue("");
        additionalInfoSelect.setValue([]);

        additionalInfoSelectDesc.clearValidators();
        additionalInfoSelect.clearValidators();

        additionalInfoSelectDesc.setValidators([Validators.required]);
        additionalInfoSelect.setValidators([Validators.required]);

        additionalInfoSelectDesc.updateValueAndValidity();
        additionalInfoSelect.updateValueAndValidity();
      } else {
        additionalInfoSelectDesc.setValue("");
        additionalInfoSelect.setValue([]);

        additionalInfoSelectDesc.clearValidators();
        additionalInfoSelect.clearValidators();

        additionalInfoSelectDesc.updateValueAndValidity();
        additionalInfoSelect.updateValueAndValidity();
      }

      this.additionalInfoSelectRequiredClassess['d-none'] = !additionalInfoSelectRequired.value;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const selected = _.get(changes, 'selected.currentValue', this.selected);
    if(selected) {
      this.setImageValueByType(selected, 'image')
      this.setImageValueByType(selected, 'thumbnail')

      this.option = this.selected;
      this.value = _.cloneDeep(this.selected.value);
    }

    if(this.option) {
      this.reNgOnInit();
    }
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  onCancel() {
    if(this.selected) {
      this.option.reset(this.value);
    }
    this.onChangeData.next(false);
  }

  saveCampaignOption() {
    const { campaign, option, selected } = this;

    const name = option.get('name');
    const trimedName = _.trim(name.value);
    name.setValue(trimedName);

    if(option.invalid) {
      option.markAllAsTouched();
      this.campaignFormService.isNotValid();
      return false;
    }

    if(selected) {
      const imageUrl = selected.get('imageUrl').value === '/images/blank_2x1.png' ?
        '':
        selected.get('imageUrl').value;
      selected.get('imageUrl').setValue(imageUrl);
      
      const thumbnailUrl = selected.get('thumbnailUrl').value === '/images/blank_1x1.png' ?
        '':
        selected.get('thumbnailUrl').value;
      selected.get('thumbnailUrl').setValue(thumbnailUrl);
   
      const optionValue = this.campaignService.generateRequestObject(selected, LongPledgePresetOptionSchema);

      this.store.dispatch({
        type: newUpdateCampaignPresetOption.type,
        payload: { campaign, option: optionValue }
      });
      return this.onCancel();
    } else {
      this.addCampaignOption();
    }
  }

  addCampaignOption() {
    const { campaign, option, option: { value } } = this;

    const imageUrl = value.imageUrl === '/images/blank_2x1.png' ? '' : value.imageUrl;
    option.get('imageUrl').setValue(imageUrl);

    const thumbnailUrl = value.thumbnailUrl === '/images/blank_1x1.png' ? '' : value.thumbnailUrl;
    option.get('thumbnailUrl').setValue(thumbnailUrl);
    
    const group = this.fb.group({});
    this.campaignService.generateForm(group, LongPledgePresetOptionSchema);
    this.campaignService.initializeForm(group, this.option.value, LongPledgePresetOptionSchema);

    option.reset();
    option.get('imageUrl').setValue("/images/blank_2x1.png");
    option.get('thumbnailUrl').setValue("/images/blank_1x1.png");

    const campaignId = _.get(campaign, 'id', null);
    const optionId = _.get(option, 'value.id', null);
    const optionValue = this.campaignService.generateRequestObject(group, LongPledgePresetOptionSchema);

    if(_.isNull(campaignId)) {
      this.store.dispatch({
        type: newAddCampaignPresetOption.type,
        payload: { option: optionValue }
      });
      return this.onChangeData.next(true);
    }

    if(_.isNull(optionId)) {
      this.store.dispatch({
        type: newCreateCampaignPresetOption.type,
        payload: { campaign, option: optionValue }
      });
      return this.onCancel();
    }

    this.store.dispatch({
      type: newUpdateCampaignPresetOption.type,
      payload: { campaign, option: optionValue }
    });
    return this.onCancel();
  }

  setImageSubscriptions(type = 'image') {
    const ratio = type === 'image' ? 2/1 : 1/1;

    this.option.get(`${type}File`).valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      if(value == 'size error'){
        this.toastService.showDanger('The picture must be at least 200px by 200px.', {delay: 3000});
      }else{
        this.openCropperModal(value, `option-${type}`, ratio)
      } 
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === `option-${type}`),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      this.option.get(`${type}DataUrl`).setValue(result);
    });
    
    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === `option-${type}`),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      if(result === false) {
        this.resetImageByType(`${type}`);
      } else {
        this.option.get(`${type}Url`).setValue(result.imageUrl);
      }
      this.cdr.markForCheck();
    });
  }
  
  openCropperModal(value, id, aspectRatio = 2/1) {
    const windowURL = window.URL || window.webkitURL;
    const url = windowURL.createObjectURL(value);
    this.imageService.cropper({
      url: this.domSanitizer.bypassSecurityTrustUrl(url),
      id: id,
      name: value.name,
      type: value.type,
      aspectRatio
    });
  }

  setImageValueByType(selected, type = 'image') {
    const ratio = type === 'image' ? '2x1' : '1x1';
    const url = selected.get(`${type}Url`).value === '/images/org_logo_default_v2.svg' ?
      `/images/blank_${ratio}.png`:
      selected.get(`${type}Url`).value;

    selected.get(`${type}DataUrl`).setValue(url);
    selected.get(`${type}Url`).setValue(url);
  }

  resetImageByType(type = 'image') {
    const ratio = type === 'image' ? '2x1' : '1x1';
    this.option.get(`${type}File`).setValue(null);
    this.option.get(`${type}DataUrl`).setValue(`/images/blank_${ratio}.png`);
    this.option.get(`${type}Url`).setValue(`/images/blank_${ratio}.png`);
  }

  onClickLearnMore() {
    const action = DialogActions.openDialog({
      payload: {
        name: "learnMore",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
      }
    });
    this.store.dispatch(action);
  }

  openChooseImageModal(type = 0) { // 0 for 2x1, 1 for 1x1
    const params = {
      start: 0,
      returnCount: 40,
      filterBy:[type]
    }

    this.campaignService.getOrganizationImages(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((imageList: any)=> {
      const list = imageList || [];
      const images = list.filter((image) => image.type === type)
      const modalRef = this.chooseImageModalService.open({ images, type });
    
      modalRef.onClose.pipe(
        takeUntil(this.takeUntilSubject)
      ).subscribe((imageUrl) =>{
        if(imageUrl) {
          const control = type === 0 ? 'image' : 'thumbnail';
          this.option.get(`${control}DataUrl`).setValue(imageUrl);
          this.option.get(`${control}Url`).setValue(imageUrl);

          this.toastService.show('success', 'Added Successfully!', {delay: 2000});
        }
        this.chooseImageModalService.modalRef = null;
      })
    })
  }

  generateThumbnail() {
    const imgUrl = this.option.get('imageUrl').value || '';
    if(imgUrl === "" || imgUrl === "/images/blank_2x1.png") {
      this.toastService.show('danger', 'Please upload an option image first.', {delay: 2500});
      return;
    }

    const params = {
      imageURL: imgUrl,
      width: 200
    }

    this.campaignService.generateThumbnail(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((response: any)=> {
      const url = response.thumbnailURL || '/images/blank_1x1.png';

      this.option.get('thumbnailDataUrl').setValue(url);
      this.option.get('thumbnailUrl').setValue(url);
      this.toastService.show('success', 'Generated Successfully!', {delay: 2000});
    })
  }

  generateSummary(summarySize = 0) {
    const description = this.option.get('desc').value || '';
    const summarySizeList = ['oneSentence', 'short', 'medium', 'long']

    if(description === "") {
      this.toastService.show('danger', 'Please add an option description first.', {delay: 2500});
      return;
    }

    const params = {
      text: description,
      summarySize: summarySizeList[summarySize]
    }

    this.campaignService.generateCSummary(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((response: any)=> {
      this.option.get('summary').setValue(response.summary);
      this.toastService.show('success', 'Generated Successfully!', {delay: 2000});
    })
  }
}
